module.exports = __webpack_public_path__ + "static/logo-49052a3edbdde84157b05d66d0f8d353.png";